import { render, staticRenderFns } from "./BaseProveedoresBaucher.vue?vue&type=template&id=7011d53d&"
import script from "./BaseProveedoresBaucher.vue?vue&type=script&lang=js&"
export * from "./BaseProveedoresBaucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports